module.exports = __webpack_public_path__ + "static/media/CIVI.c43961b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CIVI.jpg
// module id = 1717
// module chunks = 1